import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import React, { Fragment, JSX } from 'react';
import PaymentType from '@/model/PaymentType';
import OrderResponse from '@/model/OrderResponse';
import { PaymentPix } from './PaymentPix';
import { PaymentBankSlip } from './PaymentBankSlip';
import { CreditCardContent } from './CreditCardContent';

interface StateProps {
  orderResponse?: OrderResponse;
  paymentType: PaymentType;
  validating3DS: boolean;
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onCopyText: (value: string) => void;
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const PaymentContent: React.FC<Props> = ({
  orderResponse,
  paymentType,
  onCopyText,
  validating3DS,
  formData,
  onChangeFormInput,
  formErrors,
}): JSX.Element => (
  <Fragment>
    <div className="md:w-[500px] mt-[20px]">
      {orderResponse && paymentType === PaymentType.PIX && (
        <PaymentPix
          qrCodeImage={orderResponse.fileURL}
          qrCodeText={orderResponse.content}
          onCopyText={onCopyText}
        />
      )}
      {orderResponse && paymentType === PaymentType.BANK_SLIP && (
        <PaymentBankSlip
          barcode={orderResponse.content}
          fileUrl={orderResponse.fileURL}
          onCopyText={onCopyText}
        />
      )}

      {!orderResponse && paymentType === PaymentType.CREDIT_CARD && (
        <CreditCardContent
          validating3DS={validating3DS}
          formData={formData}
          onChangeFormInput={onChangeFormInput}
          formErrors={formErrors}
        />
      )}
    </div>
  </Fragment>
);
